import * as React from 'react';
import { colors } from '../../../index';

const IconCircleFive = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 21 22",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .17)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    opacity: 0.147,
    fill: "#FCFCFC",
    cx: 10.5,
    cy: 10.5,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.254 10.541L8.614 7h3.64v.834H9.38l-.214 1.937a2.292 2.292 0 011.185-.308c.647 0 1.161.214 1.542.642.38.427.57 1.005.57 1.734 0 .732-.197 1.308-.592 1.73-.395.42-.947.63-1.656.63-.628 0-1.14-.173-1.537-.521-.397-.348-.623-.83-.678-1.444h.854c.055.407.2.713.434.92.234.206.543.31.927.31.42 0 .748-.144.987-.43.24-.286.359-.681.359-1.185 0-.475-.13-.856-.388-1.144-.258-.288-.602-.432-1.032-.432-.393 0-.702.086-.926.259l-.24.195-.721-.186z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

export default IconCircleFive;